import React from "react";

function ViewUsersubcription({ user, closeModal }) {
  if (!user) return null;

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-IN");

  const isHomeAddress = user?.addressType === "Home";
  const isOfficeAddress = user?.addressType === "Office";

  const totalServices = Number(user?.plan?.totalServices || 0);
  const completedBookings = Number(user?.completedBookingsCount || 0);
  const remainingServices = Math.max(totalServices - completedBookings, 0);
  const Price = Number(user?.price || 0);
  const startDate = user?.startDate || null;
  const endDate = user?.endDate || null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content shadow-lg rounded-3">


          <div className="modal-header bg-success text-white">
            <h5 className="modal-title">User Subscription Details</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={closeModal}
            />
          </div>


          <div className="modal-body px-4 py-3">


            <div className="info-card mb-4">
              <h6 className="section-title">User Information</h6>
              <div className="row">
                <Info label="User Type" value={user?.user?.deviceType} />
                <Info label="Name" value={`${user?.user?.firstName} ${user?.lastName || ""}`} />
                <Info label="Mobile No" value={user?.user?.mobileNo} />
                <Info label="Email" value={user?.user?.email} />
                <Info label="State" value={user?.user?.stateName} />
                <Info label="City" value={user?.user?.cityName} />
                <Info label="Registration Date" value={formatDate(user?.createdAt)} />
              </div>
            </div>


            <div className="subscription-card mb-4">
              <div className="card-header">
                <h6 className="mb-0">Subscription Details</h6>
              </div>

              <div className="card-body">
                <div className="row g-4">

                  <div className="col-md-4">
                    <InfoBox label="Plan Name" value={user?.plan?.planName} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox label="Price" value={`₹ ${Price}`} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox label="Start Date" value={startDate} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox label="End Date" value={endDate} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox label="Total Services" value={totalServices} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox label="Completed Bookings" value={completedBookings} />
                  </div>

                  <div className="col-md-4">
                    <InfoBox
                      label="Remaining Services"
                      value={remainingServices}
                      highlight
                    />
                  </div>

                </div>
              </div>
            </div>



            <div className="info-card">
              <h6 className="section-title">Address Details</h6>
              <div className="row">
                <Info label="Building" value={user?.user?.bulding} />
                <Info label="Apartment" value={user?.user?.apartment} />
                <Info label="Floor" value={user?.user?.floor} />
                <Info label="Street" value={user?.user?.street} />
                <Info label="Full Address" value={user?.address} col="12" />
              </div>


              <div className="mt-3">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    checked={isHomeAddress}
                    readOnly
                  />
                  <label className="form-check-label">
                    Home Address
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    checked={isOfficeAddress}
                    readOnly
                  />
                  <label className="form-check-label">
                    Office Address
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}


const Info = ({ label, value, col = "4" }) => (
  <div className={`col-md-${col} mb-3`}>
    <div className="info-item">
      <span className="info-label">{label}</span>
      <div className="info-value">{value || "—"}</div>
    </div>
  </div>
);


const InfoBox = ({ label, value, highlight }) => {
  return (
    <div className={`info-box ${highlight ? "highlight" : ""}`}>
      <span className="info-label">{label}</span>
      <h6 className="info-value">{value ?? "-"}</h6>
    </div>
  );
};


export default ViewUsersubcription;
